<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 点检任务管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn url="extra/pointInspectTask/export/list" :params="seefrom" method="post" :needUserAccount="true"></downloadBtn>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="任务名称:">
                <el-input v-model="seefrom.taskName" placeholder="请输入任务名称"></el-input>
              </el-form-item>
              <el-form-item label="部门" prop="deptId">
                <el-select :popper-append-to-body="false" v-model="seefrom.deptId" placeholder="请选择部门" clearable>
                  <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="巡检周期:">
                <el-select :popper-append-to-body="false" v-model="seefrom.period" placeholder="请选择巡检周期" style="width:100%" clearable>
                  <el-option v-for="item in periodList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="巡检状态:">
                <el-select :popper-append-to-body="false" v-model="seefrom.isInspected" placeholder="请选择巡检状态" style="width:100%" clearable>
                  <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <br>
              <el-form-item label="巡检人:">
                <el-input v-model="seefrom.inspecterName" placeholder="请输入巡检人"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" :width="width" v-for="({prop,label,align, width}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.$index,  scope.row)">详情
                </el-link>
                <!-- <el-link icon="iconfont iconedit" type="text" size="small" @click="download(scope.$index, scope.row)" v-if="scope.row.status != 0">导出</el-link> -->
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :page-size="10" @current-change="handleCurrentChange" :total="nTotal"
              :current-page="currentPage" @size-change="sizeChangeHandle">
            </el-pagination>
          </div>
        </div>
        <el-dialog class="taskDetailDialog" :visible.sync="commandDialog" :close-on-click-modal="false" width="50%">
          <div class="titleContainer">
            <div class="titleItem" :class="{'active': activeName == 'base' }" @click="changeTab('base')">设备信息</div>
            <div class="titleItem" :class="{'active': activeName == 'content' }" @click="changeTab('content')">巡检信息</div>
          </div>
          <keep-alive>
            <template v-if="activeName === 'base'">
              <el-form class="adddevice" ref="base" :model="base" style="padding: 0; margin-top: 20px" label-width="100px">
                <el-form-item prop="fireControlSystem" label="消防系统">
                  <p>{{ formDetail.fireControlSystem }}</p>
                </el-form-item>
                <el-form-item prop="deviceType" label="设备类型">
                  <p>{{ formDetail.deviceType }}</p>
                </el-form-item>
                <el-form-item prop="deviceName" label="设备名称">
                  <p>{{ formDetail.deviceName }}</p>
                </el-form-item>
                <el-form-item prop="deptName" label="所属部门">
                  <p>{{ formDetail.deptName }}</p>
                </el-form-item>
                <el-form-item prop="qrCode" label="二维码">
                  <p>{{ formDetail.qrCode }}</p>
                </el-form-item>
                <el-form-item prop="factoryName" label="厂家名称">
                  <p>{{ formDetail.factoryName }}</p>
                </el-form-item>
                <el-form-item prop="isFrequency" label="到期提醒">
                  <p>{{ formDetail.isFrequency | filterRemind }}</p>
                </el-form-item>
                <template v-if="formDetail.isFrequency == 0">
                  <el-form-item prop="productDate" label="出厂日期">
                    <p>{{ formDetail.productDate }}</p>
                  </el-form-item>
                  <el-form-item prop="validPeriod" label="有效期(年)">
                    <p>{{ formDetail.validPeriod }}</p>
                  </el-form-item>
                </template>
              </el-form>
            </template>
            <template v-else>
              <el-form class="adddevice" ref="base" :model="base" style="padding: 0; margin-top: 20px" label-width="100px">
                <el-form-item prop="statusName" label="巡检状态">
                  <p>{{ formDetail.statusName }}</p>
                </el-form-item>
                <el-form-item prop="endTime" label="截止时间">
                  <p>{{ formDetail.endTime }}</p>
                </el-form-item>
                <el-form-item prop="inspecterName" label="巡检人员">
                  <p>{{ formDetail.inspecterName }}</p>
                </el-form-item>
                <el-form-item prop="inspectTime" label="巡检时间">
                  <p>{{ formDetail.inspectTime }}</p>
                </el-form-item>
                <el-form-item prop="inspectResult" label="巡检结果">
                  <p>{{ formDetail.inspectResult }}</p>
                </el-form-item>
                <el-form-item prop="inspectDescription" label="巡检说明">
                  <p>{{ formDetail.inspectDescription }}</p>
                </el-form-item>
                <el-form-item prop="inspectPicture" label="巡检图片">
                  <template v-if="formDetail.inspectPicture">
                    <div style="display: flex;">
                      <div v-for="(bitem, index) in formDetail.inspectPicture.split(',').filter((item) => item.indexOf('http') != -1)" :key="index">
                        <div>
                          <el-image :src="bitem" :preview-src-list="formDetail.inspectPicture.split(',').filter((item) => item.indexOf('http') != -1)"
                            style="width: 60px; height: 60px;margin: 0 10px 10px 0;">
                            <div slot="placeholder" class="image-slot">
                              加载中<span class="dot">...</span>
                            </div>
                          </el-image>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item prop="signPic" label="签名">
                  <template v-if="formDetail.signPic">
                    <div style="display: flex;">
                      <div v-for="(bitem, index) in formDetail.signPic.split(',').filter((item) => item.indexOf('http') != -1)" :key="index">
                        <div>
                          <el-image :src="bitem" :preview-src-list="formDetail.signPic.split(',').filter((item) => item.indexOf('http') != -1)"
                            style="width: 60px; height: 60px;margin: 0 10px 10px 0;background: white">
                            <div slot="placeholder" class="image-slot">
                              加载中<span class="dot">...</span>
                            </div>
                          </el-image>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-form-item>
              </el-form>
            </template>
          </keep-alive>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
var _this
export default {
  data() {
    return {
      form_jsgl: {},
      items: [],
      rules: {},
      title: '详情',
      tabName: 'jsgl',
      periodList: [
        {
          label: '每日',
          value: 0
        },
        {
          label: '每周',
          value: 1
        },
        {
          label: '每月',
          value: 2
        }
      ],
      commandDialog: false,
      seefrom: {},
      base: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      currentSize: 10,
      activeName: 'base',
      formDetail: {},
      statusList: [
        {
          label: '待巡检',
          value: 0
        },
        {
          label: '已巡检',
          value: 1
        }
      ],
      statusArr: [
        {
          label: '未巡检',
          value: 0
        },
        {
          label: '超时未巡检',
          value: 1
        },
        {
          label: '已巡检',
          value: 2
        }
      ],
      departmentList: [],
      remindList: [
        {
          label: '是',
          value: 0
        },
        {
          label: '否',
          value: 1
        }
      ]
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'taskName',
          label: '任务名称',
          width: 330
        },
        {
          prop: 'endTime',
          label: '截止时间'
        },
        {
          prop: 'periodName',
          label: '巡检周期'
        },
        {
          prop: 'deptName',
          label: '巡检部门'
        },
        {
          prop: 'statusName',
          label: '巡检状态'
        },
        {
          prop: 'inspecterName',
          label: '巡检人员'
        },
        {
          prop: 'inspectTime',
          label: '巡检时间'
        },
        {
          prop: 'inspectResult',
          label: '巡检结果'
        }
      ]
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    downloadBtn: () => import('public/download')
  },
  methods: {
    getDepart() {
      this.$axiosget('operation/deptApi/getDeptList').then((res) => {
        this.departmentList = res.data.data[0].children
      })
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.currentSize = val
      this.currentPage = 1
      this.getTableData()
    },
    //查询表格数据
    getTableData() {
      this.$axiosget('extra/pointInspectTask/page', {
        params: {
          pageSize: this.currentSize,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        this.tableData = res.data.data.list.map((item) => {
          return {
            ...item,
            statusName: this.statusArr.find(
              (bitem) => bitem.value === item.status
            ).label,
            periodName: this.periodList.find(
              (bitem) => bitem.value === item.period
            ).label,
            inspectResult: item.status == 1 ? '/' : item.inspectResult,
            inspecterName: item.status == 1 ? '/' : item.inspecterName,
            inspectTime: item.status == 1 ? '/' : item.inspectTime
          }
        })
        this.nTotal = res.data.data.total
      })
    },
    check(index, row) {
      let cloneData = _.clone(row)
      this.formDetail = cloneData
      if (this.formDetail.inspectPicture) {
        let fileUrl = process.env.fileUrl
        if (
          this.formDetail.inspectPicture &&
          this.formDetail.inspectPicture.includes(fileUrl)
        ) {
          if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
            this.formDetail.inspectPicture =
              this.formDetail.inspectPicture.replaceAll(
                fileUrl,
                process.env.SSL_HOST + '/file/'
              )
          }
        }
      }
      if (this.formDetail.signPic) {
        let fileUrl = process.env.fileUrl
        if (
          this.formDetail.signPic &&
          this.formDetail.signPic.includes(fileUrl)
        ) {
          if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
            this.formDetail.signPic = this.formDetail.signPic.replaceAll(
              fileUrl,
              process.env.SSL_HOST + '/file/'
            )
          }
        }
      }
      this.activeName = 'base'
      this.commandDialog = true
    },
    getStatusClass(val) {
      if (val == 0) {
        return 'unExecte'
      } else {
        return 'exected'
      }
    },
    changeTab(val) {
      this.activeName = val
    },
    download(index, row) {
      this.$axiospost(
        `extra/maintenanceTask/export/list?id=${
          row.id
        }&companyId=${localStorage.getItem('companyId')}`
      ).then((res) => {
        // loading.close()
        this.$message.success('下载成功!')
      })
    }
  },
  filters: {
    filterRemind(value) {
      if (_this && _this.commandDialog) {
        let item = _this.remindList.find((item) => item.value == value)
        return item ? item.label : ''
      }
    }
  },
  created() {
    this.getTableData()
  },
  mounted() {
    _this = this
    this.getDepart()
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>

<style lang="less" scoped>
/deep/ .el-pagination {
  .el-pagination__total {
    color: #b5b5b5;
  }

  .el-pagination__jump {
    color: #b5b5b5;
  }

  .el-select .el-input .el-input__inner,
  .el-pagination__jump .el-input .el-input__inner {
    background-color: #2e3657;
    border-color: rgba(221, 221, 221, 0.2);
    color: #f5f5f5;
  }
}

/deep/ .taskDetailDialog {
  .el-dialog__body {
    padding-top: 10px;
  }

  .titleContainer {
    display: flex;
    background: #2e3657;
    border: 1px solid #214c71;

    & > div {
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #c0c4cc;
      cursor: pointer;

      &.active {
        background: #262d4a;
        color: #409eff;
      }
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.statusMark {
  padding: 2px 5px;
  color: #fff;
}

.unExecte {
  background: #e03b38;
}

.exected {
  background: #3fa25a;
}

.customTable {
  margin-top: 20px;
  overflow-y: hidden;
  position: relative;
  width: 100%;

  /* 固定表头 */
  thead,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  /* 控制表格滑动 */
  tbody {
    display: block;
    height: 258px;
    overflow-y: scroll;
  }

  thead {
    background: #2e3657;
  }

  thead th {
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    color: #fff;
  }

  tbody tr {
    font-size: 14px;
    color: #ccc;

    &:nth-child(2n - 1) {
      background: transparent;
    }

    &:nth-child(2n) {
      background: rgb(34, 41, 61);
    }

    td {
      padding: 5px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/deviceInspect/inspectTaskManage/index.vue